import fontManager from 'editor/src/store/fonts/fontManager';

function isFontFileLoaded(fontFile: string) {
  return !!fontManager.loadedFontMap[fontFile];
}

export default isFontFileLoaded;
